export enum BotConfigScreen  {
    BOT_CFG_MAIN,
    BOT_CFG_CHAN_SO_HANG,
    BOT_CFG_DANH_SACH_NHOM,
    BOT_HAN_MUC_TOAN_BO,
}